export type THTTPHeaders = Record<string, string>;

export type THTTPqueryParams = Record<string, string>;

export type TApiRequestStatus = 'success' | 'failed';

export enum EApiResponseStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export interface IApiConResponse {
  status: EApiResponseStatus;
  error?: string;
}

export interface IApiResponse {
  status: 'success' | 'failed';
  error?: string;
  data?: unknown;
}
export interface IApiPostResponse extends IApiConResponse {}

export interface ISortParam {
  table: string;
  field: string;
  direction: string;
}

export interface IApiResponseDetails {
  totalPages: number;
  pageIndex: number;
  totalElements: number;
  elementsPerPage: number;
  elementsInPage: number;
  isFirst: boolean;
  isLast: boolean;
  hasNext: boolean;
  hasPrevious: boolean;
  isOverflow: boolean;
  sort: ISortParam[] | null;
}
